import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { MeControlScript } from './MeControlScript';
import { MeControlShimmer } from './MeControlShimmer';
/**
 * Separate component for handling mounting and clearing of the
 * Microsoft MeControl for user signin/signout.
 *
 */
export const MeControl = ({ meControlCommandList = [] }) => {
    if (!globalThis.msrcMeControlElement) {
        globalThis.msrcMeControlElement = _jsx(MeControlShimmer, {});
    }
    return (_jsxs(_Fragment, { children: [globalThis.msrcMeControlElement, _jsx(MeControlScript, { meControlCommandList: meControlCommandList })] }));
};
